import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
interface FAQItem {
  question: string;
  answer: string;
}
const faqData: FAQItem[] = [{
  question: '¿Y si mi hijo no come nada?',
  answer: 'El sistema incluye siempre una "base familiar" que ya aceptan. Además, el Plan B te da opciones para esos días difíciles sin culpa ni improvisación.'
}, {
  question: '¿Funciona si tengo más de un hijo?',
  answer: 'Sí. Las 30 cenas incluyen variaciones y los "puentes" permiten adaptar el mismo plato a diferentes preferencias sin cocinar múltiples comidas.'
}, {
  question: '¿Cuánto tarda en notarse un cambio?',
  answer: 'La mayoría nota menos tensión desde la primera semana. Los cambios más profundos suelen verse entre las 2-4 semanas, cuando el sistema se vuelve rutina.'
}, {
  question: '¿Sirve si mi hijo es muy selectivo?',
  answer: 'Está pensado precisamente para eso. El enfoque no es forzar, sino bajar la fricción con estructura y opciones controladas.'
}, {
  question: '¿Qué pasa si un día no sigo el plan?',
  answer: 'No pasa nada. El sistema está diseñado para la vida real. Si un día improvisás, simplemente retomás al siguiente. La consistencia importa más que la perfección.'
}, {
  question: '¿El PDF incluye medidas en gramos?',
  answer: 'Sí, todas las recetas tienen medidas en gramos para que no tengas que adivinar ni improvisar cantidades.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 px-4 bg-[#FDFBF9]" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <div className="text-center mb-12" data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E2E2E] mb-4" data-id="element-51">
            ¿Tienes dudas?
          </h2>
          <p className="text-lg text-[#2E2E2E]/70" data-id="element-52">
            Aquí respondemos todas las preguntas más comunes.
          </p>
        </div>

        <div className="space-y-3 mb-12" data-id="element-53">
          {faqData.map((item, index) => <div key={index} className="border border-[#2E2E2E]/10 rounded-lg overflow-hidden bg-white" data-id="element-54">
              <button onClick={() => toggleQuestion(index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none focus:ring-2 focus:ring-[#0D3B66] focus:ring-inset transition-colors duration-200 hover:bg-[#F6EEDC]/30" aria-expanded={openIndex === index} data-id="element-55">
                <span className="text-base font-semibold text-[#2E2E2E] pr-4" data-id="element-56">
                  {item.question}
                </span>
                <span className={`flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-57">
                  <ChevronDown className="w-5 h-5 text-[#E0435A]" data-id="element-58" />
                </span>
              </button>

              <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-59">
                <div className="px-5 pb-5" data-id="element-60">
                  <div className="bg-[#F6EEDC] rounded-lg p-4" data-id="element-61">
                    <p className="text-[#2E2E2E]/80 leading-relaxed text-sm" data-id="element-62">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-63">
          <Button variant="secondary" icon onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-64">
            Quiero el PDF ahora
          </Button>
        </div>
      </div>
    </section>;
}